<template>
  <div class="exam_contain">
    <div class="exam_select_flex">
      <div class="exam_select_box">
        <div class="exam_select_item" style="width:291px">
          <span>考生信息：</span>
          <el-input v-model="filtrate.keyword" @change="getPageList()" placeholder="可搜索姓名或手机号码"></el-input>
        </div>
        <div class="exam_select_item">
          <span style="margin-left:30px">批次：</span>
          <el-select v-model="filtrate.appraisalId" placeholder="请选择批次">
            <el-option
              v-for="(item,index) in batchList"
              :key="index"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </div>
        <div class="exam_select_item">
          <span>科目：</span>
          <el-select v-model="filtrate.subject" placeholder="请选择科目" :disabled="!filtrate.appraisalId">
            <el-option
              v-for="(item,index) in subjectList"
              :key="index"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="exam_select_item">
          <span>状态：</span>
          <el-select v-model="filtrate.status" placeholder="请选择状态">
            <el-option
              v-for="(item,index) in statusItem"
              :key="index"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="exam_select_box">
        <div class="exam_select_item">
          <span>考试日期：</span>
          <el-select v-model="filtrate.day" multiple collapse-tags placeholder="全部考试日期" >
            <el-option
              v-for="(item,index) in examDayList"
              :key="index"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="exam_select_item">
          <span>考试时间：</span>
          <el-select 
            v-model="filtrate.period"
            multiple
            collapse-tags
            placeholder="全部考试时间" 
            :disabled="!(filtrate.day.length>1 || filtrate.day[0])"
          >
            <el-option
              v-for="(item,index) in examTimeList"
              :key="index"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div class="exam_button_box">
      <el-button type="primary" :loading="searchLoading" @click="getPageList()">查询</el-button>
      <el-dropdown>
        <el-button type="primary" :loading="exportLoadingFlag">
          导出
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>
            <div ref="examInfo" @click="exportExcel()">导出考生考试情况信息EXCEL</div>
          </el-dropdown-item>
          <el-dropdown-item>
            <div @click="exportSignature()">导出全部考生签名</div>
          </el-dropdown-item>
          <el-dropdown-item>
            <div @click="checkTheSchedule()">查看导出进度</div>
          </el-dropdown-item>
          <el-dropdown-item>
            <div v-if="hasExportScoreRight" ref="scoreInfo" @click="exportScoreList()">导出成绩表</div>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <!-- 表格 -->
    <div class="table_wrapper">
      <div class="table_content">
        <el-table 
          border 
          :data="examarr" 
          max-height="650"
          @selection-change="handleSelectionChange"
          :row-key="getRowKeys"
          stripe
        >
          <el-table-column type="selection" :reserve-selection="true" width="55"></el-table-column>
          <el-table-column prop="serial" width="60" label="序号"></el-table-column>
          <el-table-column prop="examName" width="70" label="姓名"></el-table-column>
          <el-table-column prop="examPhone" width="120" label="手机号"></el-table-column>
          <el-table-column prop="examCard" width="" label="身份证号"></el-table-column>
          <el-table-column prop="appraisalBatchName" label="批次名称"></el-table-column>
          <el-table-column prop="examSubiectName" width="120" label="工种"></el-table-column>
          <el-table-column prop="examRank" width="120" label="等级"></el-table-column>
          <el-table-column prop="subject" width="70" label="科目"></el-table-column>
          <el-table-column v-if="hasExportScoreRight == true" prop="score" width="70" label="成绩"></el-table-column>
          <el-table-column prop="examTime" width="220" label="考试时间"></el-table-column>
          <el-table-column prop="addressName" width="200" label="考场名称"></el-table-column>
          <el-table-column prop="statusText" width="100" label="状态"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="{row}">
              <div class="table_content_operation">
                <!-- 查看考生信息 -->
                <el-tooltip class="item" effect="dark" :content="row.examDynamic==='invalidated'?'查看成绩作废原因':'查看报考信息'" placement="bottom">
                  <img 
                    class="operation_img" 
                    @click="studentInfoPreview(row)" 
                    src="@/assets/image/batchSignUp/icon_check.png"/>
                </el-tooltip>
                <!-- 发送短信 -->
                <el-tooltip class="item" effect="dark" content="发送短信" placement="bottom">
                  <img 
                    v-if="row.sendMsgFlag"
                    class="operation_img" 
                    @click="sendMessage(row.id)" 
                    src="@/assets/image/batchSignUp/icon_message.png"/>
                </el-tooltip>
                <!-- 编辑考生信息 -->
                <el-tooltip class="item" effect="dark" content="编辑修改" placement="bottom">
                  <img 
                    v-if="row.examDynamic === 'miss' || row.examDynamic === 'invalidated' "
                    class="operation_img" 
                    @click="studentInfoReview(row.id)" 
                    src="@/assets/image/batchSignUp/icon_edit.png" />
                </el-tooltip>
                <!-- 撤销 -->
                <el-tooltip class="item" effect="dark" content="撤销考试" placement="bottom">
                  <img
                    v-if="row.examDynamic === 'miss' && associationAuthority"
                    class="operation_img" 
                    @click="associationItem(row.reExamOrderId)" 
                    src="@/assets/image/association/icon_revoation.png"/>
                </el-tooltip>
                <!-- 成绩作废 -->
                <el-tooltip class="item" effect="dark" content="成绩作废" placement="bottom">
                  <img 
                    v-if="row.examDynamic === 'submitted'"
                    class="operation_img" 
                    @click="cancelScore(row.reExamOrderId)" 
                    src="@/assets/image/batchSignUp/icon_cancelScore.png"
                    />
                </el-tooltip>
                <!-- 修改手机号 -->
                <el-tooltip class="item" effect="dark" content="修改手机号" placement="bottom">
                  <img 
                    v-if="row.examDynamic === 'submitted'"
                    class="operation_img" 
                    @click="modifyPhoneNumber(row.id)" 
                    src="@/assets/image/batchSignUp/icon_phone.png"
                    />
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="page_footer">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[12, 24, 48, 360]"
        :page-size="limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="listCount">
      </el-pagination>
    </div>
    <!-- 发送短信对话框 -->
    <q-msg-dialog 
      v-model="sendMsgDialog"
      @sendMsg="sendMsgDialog=false" 
      :studentId="currentStudentId"
      @saveCallBack="getPageList()">
    </q-msg-dialog>
 
    <!-- 成绩作废对话框 -->
    <q-cancel-score-dialog 
      v-model="cancelScoreDialog" 
      @cancel="cancelScoreDialog=false" 
      :studentId="currentReExamOrderId"
      @saveCallBack="getPageList()">
    </q-cancel-score-dialog>
 
    <!-- 查看成绩作废对话框 -->
    <q-view-cancel-reason-dialog 
      v-model="reasonDialogFlag" 
      @cancel="reasonDialogFlag=false" 
      :studentId="currentReExamOrderId">
    </q-view-cancel-reason-dialog>
 
    <!-- 修改手机号对话框 -->
    <q-modify-phone-number 
    v-model="phoneNumberFlag" 
    :studentId="currentStudentId" 
    @cancel="phoneNumberFlag=false"
    @saveCallBack="getPageList()">
    </q-modify-phone-number>

    <!-- 导出 考生签名 对话框 -->
    <Signature ref="signature"></Signature>
  </div>
</template>
 
<script>
import {downloadBlob} from '@/utils/util.js'
import QMsgDialog from '@/view/confirm/compoment/msgDialog'
import QCancelScoreDialog from '@/view/confirm/compoment/cancelScoreDialog'
import QViewCancelReasonDialog from '@/view/confirm/compoment/viewCancelReasonDialog'
import Signature from '@/view/confirm/signature'
import QModifyPhoneNumber from '@/view/confirm/compoment/modifyPhoneNumber'
export default {
  components:{
    QMsgDialog,
    QCancelScoreDialog,
    QViewCancelReasonDialog,
    QModifyPhoneNumber,
    Signature
  },
  data() {
    return {
      multipleSelection: [],  //选中的数据
      filtrate: {
        keyword: '',
        appraisalId: '',
        subject: '',
        status: '',
        day: [],
        period: [],
      },
      page: 1,
      limit: 12,
      examarr: [],
      listCount: 0,
      batchList: [],
      subjectList: [],
      examDateList: [],
      examDayList: [],  //考试日期
      examTimeList: [],  //考试时间
      statusItem: [
        { name: '全部状态', value: '' },
        { name: '考试中', value: 'normal' },
        { name: '未考试', value: 'miss' },
        { name: '已取号', value: 'tookNumber' },
        { name: '已考试', value: 'submitted' },
        { name:'成绩作废', value: 'invalidated'}
      ],
      statusObj:{
        'normal': '考试中',
        'miss': '未考试',
        'tookNumber': '已取号',
        'submitted': '已考试',
        'invalidated': '成绩作废'
      },
      associationAuthority: false,
      exportLoadingFlag: false,
      searchLoading: false,
      sendMsgDialog:false,
      currentStudentId:'',
      currentReExamOrderId:'',
      cancelScoreDialog:false,
      reasonDialogFlag:false,
      phoneNumberFlag:false,
      hasExportScoreRight: false, // 是否有权限导出成绩
      exportProgressTimer: null
    }
  },
  watch: {
    // 考生信息
    'filtrate.keyword': function(){
      this.page = 1
      this.getPageList()
    },
    'filtrate.appraisalId':{
      handler: function() {
        if(!this.filtrate.appraisalId){
          this.subjectList = [{'name': '全部科目', 'value': ''}]
          this.filtrate.subject = ''
          return false
        }
        let subjectList = this.batchList.filter(element => element.id === this.filtrate.appraisalId)[0].subject
        subjectList.forEach(element => {
          element.value = element.name
        })
        this.subjectList = [{'name': '全部科目', 'value': ''}]
        this.subjectList = this.subjectList.concat(subjectList)
        this.getExamTime()
        this.getRightsToExportScore()
      }
    },
    'filtrate.subject': {
      handler: function() {
        this.getExamTime()
      }
    },
 
    'filtrate.day': {
      handler: function() {
        if(this.filtrate.day.length){
          this.filtrate.period = []
        }
        let list = []
        this.filtrate.day.forEach(element => {
          if(element){
            list.push(this.examDateList.filter(childElement => childElement.label === element)[0]) 
          }
        })
        let timeList = []
        list.forEach(element => {
          element.children.forEach(childElement => {
            if(!timeList.includes(childElement)){
              timeList.push(childElement)
            }
          })
        })
        this.examTimeList = []
        timeList.forEach(element => {
          this.examTimeList.push({
            'name': element,
            'value': element
          })
        })
      },
      deep: true
    },
    filtrate: {
      handler: function() {
        this.page = 1
        this.getPageList()
      },
      deep: true
    }
  },
  created() {
    this.getBatchList() 
    this.getAssociationAuthority()
  },
  beforeDestroy () {
    this.$refs.signature.clearExportProgressTimer()
  },
  computed: {
    pageCount: function() {
      return this.listCount % this.limit === 0 ? parseInt(this.listCount / this.limit) : parseInt(this.listCount / this.limit) + 1
    },
  },
  methods: {
    getBatchList: function() { //查询现有批次信息
      this.$http.get('/examination/batch/list').then(res => {
        if(res.data.success){
          this.batchList = res.data.data
          this.filtrate.appraisalId = this.batchList.find(element => element.occupationLevelCode === 'sk-003' ).id
          this.getPageList()
        }
      })
    },
    getExamTime: function() {
      let params = {
        appraisalId: this.filtrate.appraisalId,
        subject: this.filtrate.subject
      }
      this.$http.get('/examination/day/list', { params }).then(res => {
        if(res.data.success){
          this.examDateList = res.data.data
          this.formatDayList(res.data.data)
        }
      })
    },
    getPageList: function() { //获取列表数据
      let params = {
        ...this.filtrate,
        page: this.page,
        limit: this.limit
      }
      params.day = params.day.join(',')
      params.period = params.period.join(',')
      this.searchLoading = true
      this.$http.get(`/examination/list`, { params }).then((res) => {
        if (res.data.success) {
          this.listCount = res.data.data.totalCount 
          let list = res.data.data.resultList || []
          if(res.data.data.resultList){
            list.forEach((element,index) => {
              element.serial = (this.page - 1 ) * this.limit + ( index + 1)
              element.statusText = this.statusObj[element.examDynamic]
 
              //获取当前时间和考试时间，判断短信按钮是否展示
              let examDate=element.examTime.slice(0,10)
              let examTime=element.examTime.slice(11,16)
              let examDateTime=examDate+" "+examTime+":00"
              examDateTime=new Date(examDateTime)
              let currentTime=new Date()
              
              if(examDateTime.valueOf()>currentTime.valueOf()){ 
                element.sendMsgFlag=true
              }

              if(element.score == '待考试' || element.score == '缺考' || element.score == '考试中') {
                element.score = ''
              }
            })
          }
          this.examarr = list
        }
      }).finally(() => {
        this.searchLoading = false
      })
    },
    formatDayList: function(dayArray) {
      let examDayList = []
      dayArray.forEach(element => {
        examDayList.push({
          'name': element.label,
          'value': element.label
        })
      })
      this.examDayList = []
      this.examDayList = this.examDayList.concat(examDayList)
    },
    studentInfoPreview: function(row) { 
      if(row.examDynamic==='invalidated'){ //若状态为成绩作废状态，点击则弹出成绩作废原因，若非该状态，查看考生信息
        this.currentReExamOrderId=row.reExamOrderId
        this.reasonDialogFlag=true
      }else{
        this.$router.push(`/batchSignUp/preview/${row.id}/preview`)
      } 
    },
    studentInfoReview: function(id) {
      this.$router.push({
        path: `/batchSignUp/review/${id}/review`, 
        query:{ 
          appraisalId: this.filtrate.appraisalId, 
          isUpdateTime: "true"
          }
      })
    },
    sendMessage:function(id){
      this.sendMsgDialog=true
      this.currentStudentId=id
    },
    associationItem: function(id) {
      this.$alert('确定要撤销该考生的考试吗？撤销后该考生将不能参加考试', '提示', {
        confirmButtonText: '确定',
        showCancelButton: '取消',
        center: true,
        callback: action => {
          if(action === 'confirm'){
            let params = {
              id
            }
            this.$http.delete('/examination/cancel', {params}).then(res => {
              if(res.data.success){
                this.$message({
                  type: 'success',
                  message: '撤销成功'
                })
              }else {
                this.$message({
                  type: 'error',
                  message: res.data.msg || '撤销失败'
                })
              }
              setTimeout(()=>{
                this.getPageList()
              }, 300)
            })
          }
        }
      })
    },
    
    // 导出全部考生信息
    exportExcel: function() {
      let params = {
        appraisalId: this.filtrate.appraisalId,
        subject: this.filtrate.subject,
        day:'',
        period:''
      }
      params.day = this.filtrate.day.join(',')
      params.period = this.filtrate.period.join(',')
      this.exportLoadingFlag = true
      this.$http.post('/examFile/export/absence', params, {responseType: 'blob'}).then(res => {
        if(res.data){
          let filename = decodeURIComponent(res.headers.filename)
          downloadBlob(res.data, filename)
        }
        this.exportLoadingFlag = false
      }).catch(()=>{
        this.$message({
          type: 'error',
          message: '导出失败'
        })
        this.exportLoadingFlag = false
      })
    },
    
    // 导出全部考生签名
    exportSignature(){
      let params = {
        appraisalId: this.filtrate.appraisalId,
        subject: this.filtrate.subject,
        day:'',
        period:''
      }
      params.day = this.filtrate.day.join(',')
      params.period = this.filtrate.period.join(',')
      this.$http.get(`/examination/exportUndertaking`, { params }).then((res) => {
        if (res.data.success){
          this.$refs.signature.dialogTableVisible = true
          this.$refs.signature.getTaskList()
        }else{
          this.$message({
            type: 'error',
            message: res.data.msg
          })
        }
      })
    },

    // 查看导出进度
    checkTheSchedule(){
      if(this.$refs.signature.dialogTableVisible == false){
        this.$refs.signature.clearExportProgressTimer()
      }
      this.$refs.signature.dialogTableVisible = true
      this.$refs.signature.createExportProgressTimer()
    },
    getAssociationAuthority: function() {
      this.$http.get('/auth/withdrawl').then(res => {
        if(res.data.success){
          this.associationAuthority = res.data.data
        }
      })
    },
    handleSizeChange(val) {
      this.page = 1
      this.limit = val
      this.getPageList()
    },
    handleCurrentChange(val) {
      this.page = val
      this.getPageList()
    },
    handleSelectionChange(val) {  //多选方法
      this.multipleSelection = val;
    },
    getRowKeys(row) {
      return row.id + row.serial;
    },
    cancelScore(val){
      this.currentReExamOrderId=val
      this.cancelScoreDialog=true 
    },
    sendMsg(val){
      this.sendMsgDialog=val
    },
    modifyPhoneNumber(id){
      this.currentStudentId=id
      this.phoneNumberFlag=true
    },
    // 获取 导出成绩权限
    getRightsToExportScore(){
      let params = {
        appraisalBatchId: this.filtrate.appraisalId,
      }
      this.$http.get(`/registration/score/right`, {params}).then(res => {
        if(res.data.success){
          this.hasExportScoreRight = res.data.data.hasScoreRight
        }
      })
    },
    // 导出成绩表
    exportScoreList(){
      let params = {
        appraisalBatchId: this.filtrate.appraisalId, // 批次
        subject: this.filtrate.subject, // 科目
        day:'', // 考试日期
        period:'' // 考试时间
      }
      params.day = this.filtrate.day.join(',')
      params.period = this.filtrate.period.join(',')
      this.exportLoadingFlag = true
      this.$http.post('/examFile/export/score/record ', params, {responseType: 'blob'}).then(res => {
        if(res.data){
          let filename = decodeURIComponent(res.headers.filename)
          downloadBlob(res.data, filename)
        }
        this.exportLoadingFlag = false
      }).catch(()=>{
        this.$message({
          type: 'error',
          message: '导出失败'
        })
        this.exportLoadingFlag = false
      })
    }
  }
}
</script>
 
<style lang="less" scoped>
.exam_contain {
  min-width: 1800PX;
  box-sizing: border-box;
}
.exam_contain {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background: @whitee;
  width: 100%;
  padding: 30px;
  overflow: auto;
  height: 100vh;
}
.exam_button_box {
  display: flex;
  justify-content: flex-end;
  margin: 40px 0;
}
.exam_button_box button {
  width: 200px;
  height: 80px;
  margin: 0 20px 0 0;
}
.page_footer{
  width: 100%;
  height: 120px;
  display: flex;
  justify-content: center;
  align-items: center;
  .van-pagination{
    margin: 0 20px;
  }
}
.operation_img {
  width: 25PX !important;
  height: 25PX !important;
  display: block;
  margin: 0 3PX
}
.exam_select_flex {
  display: flex;
  flex-direction: column;
  margin-left: 40PX;
}
.exam_select_box{
  width: 100%;
  display: flex;
  justify-content: flex-start;
  margin-top: 50px;
}
.exam_select_item{
  white-space: nowrap;
  display: flex;
  align-items: center;
  margin-right: 320px;
 
}
.table_wrapper {
  flex: 1;
  width: 100%;
  margin: 0;
  height: 650PX;
  position: relative;
  .table_content {
    position: absolute;
    width: 100%;
    margin: 0;
    .table_content_operation{
      display: flex;
      justify-content: center;
    }
  }
}
/deep/ .has-gutter{
  color: black;
}
/deep/ .cell {
  text-align: center;
  padding: 0 10px !important;
}
/deep/ .el-table--striped .el-table__body tr.el-table__row--striped td.el-table__cell{
  background: #F0F5FA;
}
::v-deep .is-loading {
  color: white;
}
::v-deep .el-dialog {
    position: relative;
    margin: 0 auto 50px;
    background: #FFF;
    border-radius: 2px;
    box-shadow: 0 1px 3px rgb(0 0 0 / 30%);
    box-sizing: border-box;
    width: 50%;   // 改变对话框 宽度的大小，就可以调整表格的宽度了(尤其是 操作那一列的宽度)
}
</style> 

